import { render, staticRenderFns } from "./editvehicle.vue?vue&type=template&id=7a87278a&scoped=true"
import script from "./editvehicle.js?vue&type=script&lang=js&external"
export * from "./editvehicle.js?vue&type=script&lang=js&external"
import style0 from "./editvehicle.vue?vue&type=style&index=0&id=7a87278a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a87278a",
  null
  
)

export default component.exports